/** @format */

export default function disconnect(connection) {
  try {
    if (connection) {
      connection();
    }
  } catch (e) {}
}
